export type PreferredLanguageOption = {
  label: string;
  value: string;
  icon: string;
};

export const allLangs: Array<PreferredLanguageOption> = [
  {
    label: "English (UK)",
    value: "en-GB",
    icon: "/assets/icons/flags/ic_flag_en.svg",
  },
  {
    label: "English (US)",
    value: "en-US",
    icon: "/assets/icons/flags/ic_flag_us.svg",
  },
  {
    label: "French",
    value: "fr",
    icon: "/assets/icons/flags/ic_flag_fr.svg",
  },
  {
    label: "Vietnamese",
    value: "vi",
    icon: "/assets/icons/flags/ic_flag_vn.svg",
  },
  {
    label: "Chinese",
    value: "cn",
    icon: "/assets/icons/flags/ic_flag_cn.svg",
  },
  {
    label: "Arabic (Sudan)",
    value: "ar",
    icon: "/assets/icons/flags/ic_flag_sa.svg",
  },
];

export const defaultLang: PreferredLanguageOption = allLangs[0]; // English UK
